import { UserPreferenceKeys } from "./userPreferencesSlice";

import { type AllColorThemes, ColorThemes } from "../app/constants";
import { getStoredValue } from "./initialValues";

const USER_COLOR_THEMES = new Set(Object.values(ColorThemes));

const isUserColorTheme = (value: unknown): value is ColorThemes => {
  return USER_COLOR_THEMES.has(value as ColorThemes);
};

export interface ResolvedInitialColorThemes {
  colorTheme: AllColorThemes | null;
  userPreferenceColorTheme: ColorThemes | null;
}

export const resolveInitialColorThemes = (
  configuredColorTheme: AllColorThemes | null,
): ResolvedInitialColorThemes => {
  const colorThemeFromStorage = getStoredValue<AllColorThemes>(
    UserPreferenceKeys.COLOR_THEME,
  );
  const userPreferenceColorThemeFromStorage = getStoredValue<ColorThemes>(
    UserPreferenceKeys.LAST_NON_ACCESSIBLE_COLOR_THEME,
  );

  return {
    colorTheme:
      colorThemeFromStorage !== null
        ? colorThemeFromStorage
        : configuredColorTheme !== null
          ? configuredColorTheme
          : null,
    userPreferenceColorTheme:
      (isUserColorTheme(userPreferenceColorThemeFromStorage)
        ? userPreferenceColorThemeFromStorage
        : null) ??
      (isUserColorTheme(colorThemeFromStorage)
        ? colorThemeFromStorage
        : null) ??
      (isUserColorTheme(configuredColorTheme) ? configuredColorTheme : null),
  };
};
